jQuery(document).ready(function ($) {
    $(document).on('click', '.dnCookieNotice-button', function () {
        $('.dnCookieNotice').remove();
    });
});